import { Checkbox } from '@/components/ui/checkbox';

interface BooleanCellProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export function BooleanCell({ value, onChange }: BooleanCellProps) {
  return (
    <div className="flex w-full justify-center">
      <Checkbox
        checked={!!value}
        onCheckedChange={onChange ? (checked) => onChange(!!checked) : undefined}
        className={onChange ? 'cursor-pointer hover:border-highlight-default' : undefined}
      />
    </div>
  );
}
